import { Chip, List, ListItem, Typography } from '@mui/material';
import { StyledTheme } from '../../styles/styleTheme';
import { CustomDialog } from './CustomDialog';

export const CollapsedChipsList = <T extends { name: string; id: number }>({
  entities,
}: {
  entities: T[];
}) => {
  if (!entities.length) {
    return (
      <Chip label='No related memberships' variant='filled' sx={{ color: StyledTheme.tealDark }} />
    );
  }

  if (entities.length === 1) {
    return <Typography variant='subtitle2'>{entities[0].name}</Typography>;
  }

  return (
    <CustomDialog
      button={{ label: `Show (${entities.length})` }}
      modal={{
        title: 'Related Memberships',
        children: (
          <List
            sx={{
              listStyleType: 'disc',
              pl: 2,
              '& .MuiListItem-root': {
                display: 'list-item',
              },
            }}>
            {entities.map((entity) => (
              <ListItem disableGutters disablePadding key={entity?.id}>
                <Typography variant={'subtitle2'}>{entity?.name}</Typography>
              </ListItem>
            ))}
          </List>
        ),
      }}
    />
  );
};
